<template>
	<div v-if="this.orderRowMessage.message && this.orderRow"
		style="position:absolute;margin-top:5px;width:500px;margin-left:-500px;height:auto;background-color:var(--grey-1);border-radius:0px 0px 5px 5px;"
		class="drop-shadow fade" @mouseenter="!this.orderRowMessage.timeout ? this.orderRowMessage.active = true : null"
		:class="this.orderRowMessage.show ? 'fade-in' : 'fade-out'" @click="this.orderRowMessage.active = true">

		<div style="padding:0px;">
			<!-- message -->
			<div style="background:var(--grey-4);padding:10px;" class="flexcenter">
				<b style="flex-grow:1;">{{ orderRowMessage?.message }}</b>
				<Icon :fileName=" this.orderRowMessage.active ? 'w3_circle_close_dark' : 'w3_circle_close_light' "
					style="width:25px;height:25px;" @click.stop="this.close()" />
			</div>

			<div class="flexcenter" style="padding:10px;align-items: start;">
				<!-- artnr / benämning -->
				<div style="flex-grow:1;background:transparent; ">
					<b class="label">{{ this.formatArtnr(this.orderRow?.artnr) }}</b><br />
					<b class="value" style="display:block;margin-top:3px;">{{ this.orderRow?.product }}</b>
				</div>

				<div style="background:transparent;min-width:40px;">
					<b class="label">Antal</b><br />
					<div class="flexcenter">

						<Button v-if="!this.showChangeQuantity" :label="'' + this.orderRow.quantity" @click="this.changeQuantity();"
							class="grey" style="padding:3px;padding-left:5px;padding-right:5px;" />

						<!-- ändra antal -->
						<div v-if="this.showChangeQuantity" class="flexcenter"
							style="border:1px solid grey;padding:3px;border-radius: 3px;">
							<input type="text" v-model="this.newQuantity" size="3"  style="width:30px;padding:3px;border:1px;outline: none;"
								@keydown="this.updated = true" @keyup.enter="this.updateQuantity" />
							<Button label="OK" :class="this.updated ? '' : 'grey'" @click="this.updateQuantity"
								style="margin-right:0px;font-size:80%;" />
						</div>
					</div>
				</div>

				<!-- pris -->
				<div style="background:transparent;min-width:50px;text-align:right;">
					<b class="label">Pris</b><br />
					<b class="value" style="display:block;margin-top:3px;">{{ this.orderRow.price }}</b>
				</div>

				<!-- lager -->
				<div style="background:transparent;min-width:30px;text-align:right;margin-left:5px;">
					<b class="label">Lager</b><br />
					<div :class="'noInStock_' + this.orderRow.noInStockKey"
						style="padding:3px;border-radius: 5px;text-align:center;	color:white;">
						{{ this.noInStockSymbol(this.orderRow?.noInStockKey) }}
					</div>
				</div>

			</div>
			<!-- leveranstid -->
			<div v-if="this.orderRow.noInStockKey == 'OUT_OF_STOCK' && this.orderRow?.deliveryTime"
				style="padding-left:10px;padding-right:10px; ">
				<b class="label">Leveranstid</b><br />
				<b class="">{{ this.orderRow?.deliveryTime }}</b>
			</div>

			<!-- order-information -->
			<div style="padding-left:10px;padding-right:10px;margin-top:10px;">
				<b class="label">Orderinformation</b><br />
				<b class="">{{ this.order?.orderId }}, {{ this.order?.localId }}, {{ this.order?.contactPerson }}</b>
			</div>


			<!--footer -->
			<div v-if="debug && !this" style="padding:5px;">{{ this.orderRowMessage }}</div>
			<div style="background:var(--grey-dark-3);margin-top:10px;">
				<div class="flexcenter"
					style="color:white;text-align:center;font-weight:bold;padding:10px;justify-content: space-between;">
					<div class="link" @click="this.changeQuantity()">Ändra antal</div>



				</div>

			</div>





		</div>
	</div>
</template>
<script>
import { USER_STORE_ACTION, USER_STORE_GETTER } from '../store/user-store';
import { userMixin } from "@/mixins/userMixin.js";
import { productMixin } from "@/mixins/productMixin.js";

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";

export default {
	name: "OrderRowMessage",
	components: {},
	mixins: [userMixin, productMixin],
	props: {

	},
	data() {
		return {
			newQuantity: 0,
			showChangeQuantity: false,
			updated: false
		};
	},
	computed: {

		orderRowMessage() {

			var orderRowMessage = this.$store.getters[USER_STORE_GETTER.ORDER_ROW_MESSAGE];

			orderRowMessage.show = orderRowMessage.active || !orderRowMessage.timeout

			return orderRowMessage;
		},

		order(){
			const orderList = this.$store.getters[USER_STORE_GETTER.GET_ORDER_LIST_INDEXED];

			if (orderList && this.orderRowMessage?.orderId) {

				return orderList[this.orderRowMessage?.orderId];
			}
			return null;
		},

		orderRow(){

			if (this.order) {
				const orderRow = this.order.orderRowList?.find(orderRow => orderRow.orderRowId == this.orderRowMessage.orderRowId);

				return orderRow;

			}

			return null
		}





	},
	watch: {

	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });
		close(){
			this.orderRowMessage.active = false;
			this.orderRowMessage.timeout = true;
			this.orderRowMessage.message = null;
		},
		changeQuantity() {
			this.showChangeQuantity = true
			this.newQuantity = this.orderRow.quantity
			this.updated = false
		},

		updateQuantity() {

			if (!this.order){
				alert("Order saknas");
			}

			if (!this.order.canBeEdited) {
				alert("Ordern är redan beställd och orderraden kan inte ändras");
				return;
			}

			this.order.meta.updating = true
			this.spinner = true;

			const data = { currentOrderId: this.order.orderId, post: { orderRowId: this.orderRow.orderRowId, quantity: this.newQuantity } }
			this.$store.dispatch({ type: USER_STORE_ACTION.UPDATE_ORDER_ROW, data: data }).finally(() => {
				this.order.meta.updating = false
				this.spinner = false
				this.showChangeQuantity = false;

			})
		}
	},
	
};
</script>

<style scoped>

b.label{
	font-size:80%;
	color:var(--font-color-dark);

}
b.value {
	color: var(--font-color-darkest);

}
</style>